<template>
  <div class="topic-row topic-header">
    <div class="subscription-col topic-header-label"  @click="toggleOpen">
      <div>
        <span :class="caretObject"></span>
        Topic Subscriptions
      </div>
    </div>
    <!-- <div class="subscription-col">
      <div class="imidiate-email">
        <input type="checkbox" v-model="immediate" @change="immediateChanged">
        <span>Immediate</span>
      </div>
    </div>
    <div class="subscription-col">
      <input type="checkbox" v-model="notification" @change="notificationChanged">
      <span>Immediate</span>
    </div> -->
  </div>
</template>

<script>
export default {
  props: ['notificationProp', 'isOpen'],
  data() {
    return {
      notification: false,
      immediate: false,
      daily: false,
      weekly: false,
    }
  },
    computed: {
      caretObject() {
          return {
              'caret': true,
              'caret-down': this.isOpen
          }
      }
    },
  created() {
    this.notification = this.notificationProp;
  },
  watch: {
    notificationProp(newValue) {
      this.notification = newValue;
    },
  },
  methods: {
    notificationChanged() {
      this.$emit('changenotification', this.notification);
    },
    immediateChanged() {
      this.$emit('immediateChanged', this.immediate);
    },
    dailyChanged() {
      this.$emit('dailyChanged', this.daily);
    },
    weeklyChanged() {
      this.$emit('weeklyChanged', this.weekly);
    },
    toggleOpen() {
        this.$emit('toggleOpen');
    }
  }
}
</script>
